import { useCallback, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import FeedbackReport from '../../Practice/PracticeReview/FeedbackReport';
import DetailCard from '../components/DetailCard';
import DetailHeader from '../components/DetailHeader';
import InfoList from '../components/InfoList';
import LoadStatus from '../components/LoadStatus';
import StatusBadge from '../components/StatusBadge';
import { getAiClientFeedback } from './aiClientApi';
import { AI_CLIENT_STATUS_LABELS, formatDuration } from './aiClientStatus';
// 사용자 화면 리포트 컴포넌트가 쓰는 스타일. 사용자 쪽 ReviewLayout이 불러오던 것을 여기서 직접 불러온다.
import '../../Practice/AIClients/AIClients.css';
import '../../Practice/PracticeReview/PracticeReview.css';
import './AiClientResultDetailPage.css';

const BACK = { backTo: '/admin/ai-clients', backLabel: 'AI 내담자 결과 목록' };

// 목록에서 넘겨받은 행으로 기본 정보 항목을 만든다. 주소로 바로 들어오면 행이 없어 연습 ID만 보여준다.
function toInfoItems(instanceId, row) {
    if (!row) return [{ label: '연습 ID', value: instanceId }];
    return [
        { label: '사용자', value: row.user_name },
        { label: '이메일', value: row.user_email },
        { label: 'AI 내담자', value: row.client_name },
        { label: '연습 주제', value: row.topic },
        { label: '진행일', value: row.practiced_at },
        { label: '면담 시간', value: formatDuration(row) },
        { label: '연습 ID', value: instanceId },
    ];
}

// AI 내담자 사용 내역 상세 화면. 기본 정보와 사용자 화면과 같은 피드백 리포트를 보여준다(연습 링크·피드백 폼은 숨김).
export default function AiClientResultDetailPage() {
    const { instanceId } = useParams();
    const row = useLocation().state?.row;
    // undefined: 불러오는 중, null: 리포트 없음
    const [feedback, setFeedback] = useState(undefined);
    const [error, setError] = useState('');

    // 피드백 리포트를 불러온다.
    const load = useCallback(async () => {
        setError('');
        setFeedback(undefined);
        try {
            setFeedback(await getAiClientFeedback(instanceId));
        } catch (loadError) {
            setError(loadError.message);
        }
    }, [instanceId]);

    useEffect(() => { load(); }, [load]);

    const title = row ? `${row.client_name || 'AI 내담자'} · ${row.user_name || row.user_email || '사용자'}` : 'AI 내담자 연습 결과';
    const badge = row && <StatusBadge label={AI_CLIENT_STATUS_LABELS[row.status] || row.status} done={row.status === 'completed'} />;

    return (
        <>
            <DetailHeader {...BACK} title={title} aside={badge} />
            <DetailCard title="기본 정보"><InfoList items={toInfoItems(instanceId, row)} /></DetailCard>
            {feedback === undefined && <LoadStatus error={error} onRetry={load} />}
            {feedback === null && <DetailCard title="종합 피드백"><p className="muted">사용자가 아직 피드백 리포트를 받지 않은 연습입니다.</p></DetailCard>}
            {feedback && <div className="review-page admin-result-report"><FeedbackReport analysis={feedback} showPracticeLinks={false} /></div>}
        </>
    );
}
